<div class="users-page">
  <div class="page-head">
    <div>
      <h1>{{ titleText }}</h1>
    </div>
  </div>

  <!-- Телефон: выбор роли выпадающим меню вместо строки вкладок -->
  <div class="role-select" *ngIf="!loading && !error">
    <button type="button" class="role-select__btn" (click)="roleMenuOpen = !roleMenuOpen" [attr.aria-expanded]="roleMenuOpen">
      <svg class="role-select__burger" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
      {{ activeTabMobileLabel }}
      <span class="role-tab__count">{{ roleCount(activeRole) }}</span>
      <svg class="role-select__chevron" [class.open]="roleMenuOpen" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
    </button>
    <div class="role-select__backdrop" *ngIf="roleMenuOpen" (click)="roleMenuOpen = false"></div>
    <div class="role-select__menu" *ngIf="roleMenuOpen" role="listbox">
      <button type="button" *ngFor="let tab of visibleTabs" role="option" [class.active]="activeRole === tab.key"
              [attr.aria-selected]="activeRole === tab.key" (click)="selectRole(tab.key); roleMenuOpen = false">
        {{ tab.key === 'all' ? allUsersText : tabLabel(tab) }}
        <span class="role-tab__count">{{ roleCount(tab.key) }}</span>
      </button>
    </div>
  </div>

  <!-- Вкладки по ролям; пустые роли не показываются -->
  <nav class="role-tabs" *ngIf="!loading && !error" role="tablist">
    <button type="button" *ngFor="let tab of visibleTabs" role="tab" class="role-tab"
            [class.active]="activeRole === tab.key" [attr.aria-selected]="activeRole === tab.key" (click)="selectRole(tab.key)">
      {{ tabLabel(tab) }}
      <span class="role-tab__count">{{ roleCount(tab.key) }}</span>
    </button>
  </nav>

  <section class="card">
    <div class="card-toolbar">
      <form [formGroup]="searchForm" class="search-form">
        <svg class="search-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
        <input
          type="text"
          formControlName="searchTerm"
          [placeholder]="searchPlaceholderText"
          class="search-input"
        />
        <button type="button" *ngIf="searchTerm" (click)="clearSearch()" class="clear-button" aria-label="✕">✕</button>
      </form>
    </div>

    <div *ngIf="error" class="error-message">{{ error }}</div>
    <div *ngIf="loading" class="loading-message">{{ loadingText }}</div>

    <div *ngIf="!loading && !error" class="table-wrap">
      <table class="users-table" *ngIf="sortedUsers.length > 0">
        <thead>
          <tr>
            <!-- Email и телефон — в одном столбце, чтобы таблица помещалась по ширине; сортировка — по каждому полю -->
            <th *ngFor="let group of columnGroups" [attr.aria-sort]="groupAriaSort(group)">
              <div class="sort-group">
                <ng-container *ngFor="let col of group; let last = last">
                  <button type="button" class="sort-button" [class.sorted]="sortKey === col.key" (click)="sortBy(col.key)">
                    {{ col.label() }}
                    <span class="sort-icon" aria-hidden="true">{{ sortIcon(col.key) }}</span>
                  </button>
                  <span class="sort-sep" *ngIf="!last" aria-hidden="true">·</span>
                </ng-container>
              </div>
            </th>
            <th class="actions-head">{{ actionsText }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of sortedUsers" class="user-row">
            <td class="user-td">
              <button type="button" class="user-cell" (click)="viewUser(user.id)">
                <span class="avatar">{{ initials(user.fullName) }}</span>
                <span class="user-name">{{ user.fullName }}</span>
              </button>
            </td>
            <td class="contacts">
              <span class="email">{{ user.email }}</span>
              <span class="phone">{{ user.phone || '—' }}</span>
            </td>
            <td class="nowrap registered">
              <ng-container *ngIf="user.createdAt; else noDate">
                <span class="date">{{ user.createdAt | date:'dd.MM.yyyy' }}</span>
                <small class="time">{{ user.createdAt | date:'HH:mm' }}</small>
              </ng-container>
              <ng-template #noDate><span class="muted">—</span></ng-template>
            </td>
            <td class="actions-cell">
              <button type="button" class="view-button" (click)="viewUser(user.id)" [attr.aria-label]="viewText" [title]="viewText">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>
                <span class="view-button__text">{{ viewText }}</span>
              </button>
              <button type="button" class="view-button login-as-button" *ngIf="canLoginAs(user)" (click)="loginAs(user)" [attr.aria-label]="loginAsText + ': ' + user.fullName" [title]="loginAsText">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/></svg>
                <span class="view-button__text">{{ loginAsText }}</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="sortedUsers.length === 0" class="no-users">{{ noUsersText }}</div>
    </div>
  </section>
</div>
